import React, { useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import ShowMoreAndLess from '@components/filterComponents/showMoreAndLess';

import { setFilters } from '@store/common/action';
import { getCommonFilters } from '@store/reducers';

import { _getKey, capitalizeFirstLetter } from '@utils/Util';

const CommonCheckBoxFilters = ({ type, data, nameWithSpace, title, onSearchItem, showFilter = true }) => {
	const [searchData, setSearchData] = useState('');
	const [showMore, setShowMore] = useState(false);
	const dispatch = useDispatch();
	const commonfilters = useSelector(getCommonFilters);
	const selectedRef = useRef();

	const filterData = data?.filter((item) =>
		item.name.toLowerCase().includes(searchData.toLocaleLowerCase())
	);

	const onSearchData = (e) => {
		setSearchData(e.target.value);
		if (onSearchItem) {
			onSearchItem(e.target.value);
		}
	};

	const isSelected = (item) => {
		let tempType = type;
		if (tempType === 'constructions' && item?.fabricType === 'FIXED') tempType = 'fabricTypes';
		else if (item?.isPrimary) tempType = 'mainCategoryIds';

		const selected = commonfilters[tempType]?.find((obj) => obj.id === item?.id);
		return !!selected;
	};

	const onChange = (item) => {
		let tempType = type;
		if (tempType === 'constructions' && item?.fabricType === 'FIXED') tempType = 'fabricTypes';
		else if (item?.isPrimary) tempType = 'mainCategoryIds';

		if (isSelected(item)) {
			const newSelectedItems = commonfilters[tempType]?.filter((i) => i.id !== item.id);
			dispatch(setFilters({ ...commonfilters, [tempType]: newSelectedItems }));
		} else {
			dispatch(setFilters({ ...commonfilters, [tempType]: [...commonfilters[tempType], item] }));
		}
	};

	return (
		<div className="filter-content">
			<div id="accordion">
				<div className="card">
					<div className="card-header" id="headingBrand">
						<h5 className="mb-0">
							<button
								className="btn btn-link collapsed"
								data-toggle="collapse"
								data-target={`#${title}`}
								aria-expanded="true"
								aria-controls={`${title}`}
								// onClick={() => selectedRef.current.focus()}
							>
								{nameWithSpace ? nameWithSpace : title}
							</button>
						</h5>
					</div>
					<div id={`${title}`} className="collapse" aria-labelledby="headingBrand">
						<div className="card-body">
							<div className="form-group size36 m-0 search-filter">
								{showFilter && (
									<div className="with-icon right-icon">
										<input
											type="text"
											autoComplete="off"
											placeholder="Search"
											ref={selectedRef}
											onChange={(e) => onSearchData(e)}
										/>
										<span className="right-icon">
											<svg
												width={17}
												height={17}
												viewBox="0 0 17 17"
												fill="none"
												xmlns="http://www.w3.org/2000/svg"
											>
												<path
													fillRule="evenodd"
													clipRule="evenodd"
													d="M7.5 0C11.6421 0 15 3.35786 15 7.5C15 9.21015 14.4276 10.7866 13.464 12.0483L16.7071 15.2929C17.0976 15.6834 17.0976 16.3166 16.7071 16.7071C16.3466 17.0676 15.7794 17.0953 15.3871 16.7903L15.2929 16.7071L12.0483 13.464C10.7866 14.4276 9.21015 15 7.5 15C3.35786 15 0 11.6421 0 7.5C0 3.35786 3.35786 0 7.5 0ZM7.5 2C4.46243 2 2 4.46243 2 7.5C2 10.5376 4.46243 13 7.5 13C8.85114 13 10.0885 12.5128 11.0459 11.7045C11.091 11.5536 11.1738 11.412 11.2929 11.2929C11.412 11.1738 11.5536 11.091 11.7041 11.0446C12.5128 10.0885 13 8.85114 13 7.5C13 4.46243 10.5376 2 7.5 2Z"
													fill="#9AA1AF"
												/>
											</svg>
										</span>
									</div>
								)}
							</div>
							<div className="custom-chekbox">
								{filterData?.map((item, index) =>
									!showMore && index > 6 ? (
										''
									) : (
										<div className="form-group" key={_getKey()}>
											<input
												type="checkbox"
												id={item.id}
												name={item.name}
												onChange={() => onChange(item)}
												checked={isSelected(item)}
											/>
											<label htmlFor={`name_${item.id}`} onClick={() => onChange(item)}>
												<span
													className={`${
														item?.isPrimary === true ? 'option-label' : ''
													}`}
												>
													{type === 'certificateTypeList'
														? item.name.toUpperCase()
														: capitalizeFirstLetter(item.name)}
												</span>
											</label>
										</div>
									)
								)}
								{filterData?.length > 6 && (
									<ShowMoreAndLess
										showMore={showMore}
										setShowMore={setShowMore}
										items={filterData}
									/>
								)}
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default CommonCheckBoxFilters;
